import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { ModelTransformer } from '../common/common.model';
import { mapList, mapRetrieve } from '../common/rest.operators';

import { Args, Data, DataModelSetTransformer } from './form.model';

@Injectable()
export class TemplateFormService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveMetadata<T, U = T>(
        templateId: number,
        transformer?: ModelTransformer<T, U>,
    ): Observable<T> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.FORM}/templates/${templateId}/metadata`,
            )
            .pipe(
                mapRetrieve(transformer),
                catchError(() => of(null)),
            );
    }

    listData<T, U = T, V = any>(
        templateId: number,
        args?: Args<V>,
        transformer?: ModelTransformer<T, U>,
    ): Observable<Array<Data<T>>> {
        return this._http
            .post(
                `${this._appConfig.API_ENDPOINTS.FORM}/templates/${templateId}/data`,
                args,
            )
            .pipe(
                mapList(new DataModelSetTransformer(transformer)),
                catchError(() => of([])),
            );
    }
}
